import { api } from 'constants/constant';
import { getHeaders, CheckAuth } from 'auth/auth';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const isUuidLike = (value) => {
  if (!value) return false;
  return /^[0-9a-fA-F-]{36}$/.test(String(value));
};

const isConsumerUser = () => {
  const cachedUser = CheckAuth() || {};
  const role = String(cachedUser.role || cachedUser.originalRole || '').toLowerCase();
  const userId = cachedUser.user_id;
  return role === 'consumer' || isUuidLike(userId);
};

export const notificationsAPI = createApi({
  reducerPath: 'notifications',
  tagTypes: ['fetch-notifications'],
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: ({ showUnread }) => {
        // B2C consumers use /b2c/notifications/, B2B uses /b2b/loan/notification/
        const url = isConsumerUser()
          ? `b2c/notifications/?page=1&page_size=100&is_unread=${showUnread}`
          : `b2b/loan/notification/?page=1&page_size=100&is_unread=${showUnread}`;
        return {
          url,
          method: 'GET',
          headers: getHeaders(),
        };
      },
      providesTags: ['fetch-notifications'],
    }),

    updateNotifications: builder.mutation({
      query: ({ data }) => {
        // B2C consumers use /b2c/notifications/, B2B uses /b2b/loan/notification/
        const url = isConsumerUser()
          ? `b2c/notifications/`
          : `b2b/loan/notification/`;
        return {
          url,
          method: 'PUT',
          body: data,
          headers: getHeaders(),
        };
      },
      invalidatesTags: ['fetch-notifications'],
    }),
  }),
});

export const { useGetNotificationsQuery, useUpdateNotificationsMutation } =
  notificationsAPI;
